import React from 'react';
import TableRow from "@mui/material/TableRow";
import Skeleton from '@mui/material/Skeleton';
import TableCell from "@mui/material/TableCell";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import EditIcon from '@mui/icons-material/Edit';
import moment from "moment";
import {Link} from "react-router-dom";
import HasRight from "../../../../Route/HasRight";
import {getFanclubPlanEditRoute} from "../../../../../router/routes/fanclub/factory/plan";
import Button from "../../../inputs/Button";

const Row = ({plan}) => {

    const displayPlan = (plan);

    return (
        <TableRow>
            <TableCell component="th" scope="row">
                {!displayPlan && <Skeleton variant="circular" width={40} height={40}/>}
                {(displayPlan && plan.Visible === 'Y') && <VisibilityIcon/>}
                {(displayPlan && plan.Visible === 'N') && <VisibilityOffIcon/>}

            </TableCell>
            <TableCell>
                {!displayPlan && <Skeleton/>}
                {displayPlan &&
                <span>{plan.Priority}</span>
                }
            </TableCell>
            <TableCell>
                {!displayPlan && <Skeleton/>}
                {displayPlan && <span>{plan.Catalog_Product['Basic.Name']}</span>}
            </TableCell>
            <TableCell align="right">
                {!displayPlan && <Skeleton/>}
                {displayPlan && <span>{moment(parseInt(plan.Created.unixms)).format('LLL')}</span>}
            </TableCell>
            <TableCell align="right">
                {!displayPlan && <Skeleton/>}
                {displayPlan &&
                <HasRight admin hideLoading>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<EditIcon/>}
                        component={Link} to={getFanclubPlanEditRoute(plan.Membership_Plan__)}
                    >
                        Edit
                    </Button>
                </HasRight>
                }
            </TableCell>
        </TableRow>
    );
};


export default Row;